import { useEffect } from 'react';
import styles from './Callback.module.css';
import { useCallback } from './Callback.hooks';

import { Loading } from '@/components/loading/Loading';

export const Callback = () => {
	// const navigate = useNavigate();
	const { isLoading, error, url, code } = useCallback();
	useEffect(() => {
		if (isLoading) {
			return;
		}
		if (!error) {
			// navigate('/');
			location.href = url;
		}
	}, [isLoading]);
	if (error) {
		return (
			<div className={styles['error']}>
				<div>
					<p>{error.message}</p>
					<p>
						Please copy this code and send it to support for further
						assistance
					</p>
					<div className={styles['code']}>{code}</div>
				</div>
			</div>
		);
	}
	return (
		<div className={styles['loading']}>
			<Loading />
		</div>
	);
};
